import { images } from '../constants'; 

const museoData = [  
    {
        id: 1,
        image: images.museo1,
        titleKey: "museo.title",
        date: "",
        paragraphsKeys: [
            "museo.paragraphs.0",
            "museo.paragraphs.1",
            "museo.paragraphs.2",
            "museo.paragraphs.3",
            "museo.paragraphs.4",
            "museo.paragraphs.5",
            "museo.paragraphs.6",
            "museo.paragraphs.7"
        ],
        agenda: {
            introKey: "museo.agenda.intro",
            pointsKeys: [
                "museo.agenda.points.0",
                "museo.agenda.points.1",
                "museo.agenda.points.2",
                "museo.agenda.points.3",
                "museo.agenda.points.4"
            ],
            endKey: "museo.agenda.end"
        },
        gallery: [
            images.eksponat1,
            images.eksponat2,
            images.eksponat3,
            images.eksponat4,
            images.eksponat5,
            images.eksponat6,
            images.eksponat7,
            images.eksponat8,
        ]
    },
];

export default museoData;